<template lang="pug">
  transition(
    appear
    name="imenu"
    v-on:enter="enter"
    v-on:leave="leave"
  )
    .menu
      //.bg-yellow(ref="bgYellow")
      .bg-blank(@click="btnClose")
      .bg-blue(ref="bgBlue")
        .bg-yellow(:class="{'active': show.gallery}")
        bg-pattern
        img.bg-spark(src="~assets/ui/spark.png")
        .button-back(ref="backBtn" @click="btnBack" :class="{'active': show.questions||show.qr||show.gallery}")
          icon-arrow
        .button-close(@click="btnClose" v-if="show.close")
          icon-close
        .btns(ref="btns" :class="{'hide': btnHide}")
          .btn.btn-follow(@click="btnFollow")
            //img(src="~assets/ui/menu/b1.png")
            svg
             use(xlink:href="#icon-heart")
            span 关注加州旅游局
          //.btn.btn-follow(@click="qrBtn")
            img(src="~assets/ui/menu/b1.png")
          .btn.btn-subtitle(@click="btnSubtitle")
            //img(src="~assets/ui/menu/b2.png")
            svg
              use(xlink:href="#icon-eye")
            span 字幕
            .switch
              button-switch(:initState="showSubtitles" ref="subtitleSwitch")
          .btn.btn-sound(@click="btnMute")
            //img(src="~assets/ui/menu/b3.png")
            svg
              use(xlink:href="#icon-sound")
            span 声音
            .switch
              button-switch(:initState="!muted" ref="soundSwitch")
          .btn.btn-question(@click="btnQuestion")
            //img(src="~assets/ui/menu/b4.png")
            svg
              use(xlink:href="#icon-question")
            span 常见问题
          .btn.btn-gallery(@click="btnGallery" v-if="gallery.length>0")
            img(src="~assets/ui/menu/b5.png")
            svg
              use(xlink:href="#icon-bag")
            span 相册背包
          //.btn.btn-gallery(@click="galleryBtn" v-if="gallery.length>0")
            img(src="~assets/ui/menu/b5.png")
          //.btn.btn-gallery(@click="showSubContent('gallery')")
            img(src="~assets/ui/menu/b5.png")
        questions(ref="questions" :class="{'active': show.questions}")
        qr-menu(ref="qr" :class="{'active': show.qr}")
        menu-gallery(:active="show.gallery" ref="gallery" :class="{'active': show.gallery}")


</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3, Power2} from 'gsap'
//import Component from '@/components/Component'
import IconClose from 'src/components/vca/widgets/IconClose'
import IconArrow from 'src/components/vca/widgets/IconArrow'
import QRMenu from 'src/components/vca/widgets/QRMenu'
import ButtonSwitch from 'src/components/vca/widgets/ButtonSwitch'
import Questions from './Questions2'
import BgPattern from 'src/components/vca/widgets/BgPattern'
import MenuGallery from 'src/components/vca/widgets/MenuGallery'

import AnalyticsService from '@/services/AnalyticsService'

export default {
  name: "Menu",
  props: {

  },
  components: {
    IconArrow,
    IconClose,
    Questions,
    ButtonSwitch,
    'qr-menu':QRMenu,
    BgPattern,
    MenuGallery
  },
  data() {
    return {
      //showBackBtn: false,
      secondLevelEl: null,
      show: {
        questions: false,
        qr: false,
        close: false,
        gallery: false
      },
      btnHide: true
    }
  },
  computed:{
    ...mapState('app', ['showMenu', 'showSubtitles', 'muted', 'gallery'])
  },
  methods: {
    ...mapMutations('app', ['closeMenu', 'openQRPage', 'toggleMuted', 'toggleSubtitles', 'openGallery']),
    init() {
      //this.showBackBtn = false
    },
    animateIn(cb) {

      let tl = new TimelineMax({
        onComplete: () => {
          this.show.close = true
          cb()
        },
        // onReverseComplete: () =>{
        //   this.show.close = false
        // }
      })
      this.tl = tl

      this.btnHide = false

      // this.staggerTo = TweenMax.staggerTo(
      //   this.$refs.btns.childNodes,
      //   0.6,
      //   {
      //     x: 0,
      //     opacity: 1,
      //     ease: Power2.easeOut,
      //     delay: 0.4
      //   },
      //   0.1,
      //
      //   //`start+=0.1`
      // )

      tl.add('start')

        .to(
          this.$refs.bgBlue,
          0.6,
          {
            x: 0,
            ease: Power2.easeInOut
          },
          `start+=0`
        )

    },

    btnAnimLeft() {
      //let f = this.normalDecay(MathUtils.randomInRange(0, 2),1)

      let tl = new TimelineMax({ })
      this.tl = tl
      let dur = 1

      //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
      //console.log(444, this.$refs.btns.childNodes)
      tl.add('start')
        .staggerTo(
          this.$refs.btns.childNodes,
          dur,
          {
            x: 0,
            ease: Power2.easeOut,
          },
          0.1,
          `start+=0.2`
        )

    },

    showSubContent(ref){
      //this.secondLevelEl = this.$refs[ref].$el
      this.subContent = ref
      this.btnHide = true
      this.show[ref] = true

      // if (this.tlq)
      //   this.tlq.kill()
      // this.subContent = ref
      // let tl = new TimelineMax({
      //   onComplete: ()=> {
      //     //this.showBackBtn = true
      //     this.show[ref] = true
      //   },
      //   onReverseComplete: () => {
      //     //this.showBackBtn = false
      //   }
      //
      // })
      // this.tlq = tl
      //
      // tl.add('start')
        // .staggerTo(
        //   this.$refs.btns.childNodes,
        //   0.7,
        //   {
        //     x: -50,
        //     opacity: 0,
        //     ease: Power2.easeIn,
        //   },
        //   0.1,
        //   `start+=0`
        // )

    },
    closeSubContent(){
      this.show[this.subContent] = false
      this.btnHide = false
      // let tl = new TimelineMax({
      //   onComplete: ()=> {
      //     //this.showBackBtn = false
      //   },
      //
      // })
      // this.tlq = tl
      //
      // tl.add('start')
      //   .staggerTo(
      //     this.$refs.btns.childNodes,
      //     0.7,
      //     {
      //       x: 0,
      //       opacity: 1,
      //       ease: Power2.easeOut,
      //     },
      //     0.1,
      //     `start+=0.4`
      //   )
    },

    btnBack(){
      //this.tlq.reverse()
      this.closeSubContent()
    },
    btnClose(){

        this.closeMenu()
      //}
    },
    btnFollow(){
      AnalyticsService.sendEvent('menu', 'click', 'button-follow')
      this.showSubContent('qr')
    },
    btnMute(){
      AnalyticsService.sendEvent('menu', 'click', 'button-mute')
      if (this.muted){
        this.toggleMuted()
        this.$refs.soundSwitch.animateOn()
      } else{
        this.toggleMuted()
        this.$refs.soundSwitch.animateOff()
      }
    },
    btnSubtitle(){
      AnalyticsService.sendEvent('menu', 'click', 'button-subtitle')
      if (this.showSubtitles) {
        this.toggleSubtitles()
        this.$refs.subtitleSwitch.animateOff()
      }
      else{
        this.toggleSubtitles()
        this.$refs.subtitleSwitch.animateOn()
      }
    },
    btnQuestion(){
      AnalyticsService.sendEvent('menu', 'click', 'button-question')
      this.showSubContent('questions')
    },
    btnGallery(){
      AnalyticsService.sendEvent('menu', 'click', 'button-gallery')
      this.showSubContent('gallery')
    },

    // subtitleBtn(){
    //   if (this.showSubtitles) {
    //     this.toggleSubtitles()
    //     this.$refs.subtitleSwitch.animateOff()
    //   }
    //   else{
    //     this.toggleSubtitles()
    //     this.$refs.subtitleSwitch.animateOn()
    //   }
    // },
    // soundBtn(){
    //   if (this.muted){
    //     this.toggleMuted()
    //     this.$refs.soundSwitch.animateOn()
    //   } else{
    //     this.toggleMuted()
    //     this.$refs.soundSwitch.animateOff()
    //   }
    // },

    enter(el, done){
      console.log('enter')
      this.animateIn(done)

    },
    leave(el, done){
      let cb = () => {
        this.show.close = false
        done()
      }
      this.tl.eventCallback('onReverseComplete', cb)
      //this.tl.remove(this.staggerTo)
      //console.log(this.tl)
      this.tl.reverse()

    },
    galleryBtn(){
      this.closeMenu()
      this.openGallery()
    },
    qrBtn(){
      this.closeMenu()
      this.openQRPage()
    }
  },
  mounted() {
    this.init()
    //this.animateIn()
    //this.animate()

    //this.btnAnimLeftIn()
  },
  beforeDestroy(){
    //this.tl.reverse()
  },
  watch: {
    // showMenu(val){
    //   if(val){
    //     this.animateIn()
    //   } else{
    //     this.tl.reverse()
    //   }
    // }
  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .menu
    //pointer-events: all
    +full()

    .button-close
      position: absolute
      width: 0.4rem
      height: 0.4rem
      font-size: $fs-m
      top: $ui-margin
      right: $ui-margin/2
      //pointer-events: all
      z-index: 110
    .button-back
      //background: #e15125
      z-index: 110
      padding: 0.1rem 0.2rem
      position: absolute
      line-height: 0
      transform: scale(-1) translateX(100%)
      width: 0.53rem
      top: $ui-margin - 0.1rem
      left: 0.1rem
      //pointer-events: all
      opacity: 0
      transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1)
      &.active
        transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 1s
        transform: scale(-1) translateX(0)
        opacity: 1


    //.bg-yellow
      +full()
      background: $cl-yellow
      opacity: 0
    .bg-blank
      position: absolute
      top: 0
      right: 0
      width: 14%
      height: 100%
    .bg-blue
      overflow: hidden
      position: absolute
      top: 0
      left: 0
      width: 86%
      height: 100%
      //background: $cl-blue
      box-shadow: 4px 0 4px rgba(0, 0, 0, 0.25)
      padding-top: 1.1rem
      transform: translateX(-100%)
      background: linear-gradient(189.5deg, #3859A8 27.25%, #133E8E 99.06%)
      .bg-yellow
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: linear-gradient(171.36deg, #FD9F02 69.87%, #E68203 112.08%)
        transform: translate3d(100%, 0, 0)
        transition: transform 0.7s cubic-bezier(0.23, 1, 0.32, 1)
        &.active
          transition: transform 0.7s cubic-bezier(0.23, 1, 0.32, 1) 0.7s
          transform: translate3d(0, 0, 0)
      .bg-pattern
        mix-blend-mode: color-burn
      .bg-spark
        position: absolute
        top: 0
        left: 0
        display: block
        width: 100%
        height: 100%
        object-fit: fill
      .btns
        width: 100%
        display: flex
        flex-direction: column
        justify-content: flex-start
        align-items: center
        padding-left: 0.4rem
        .btn-follow
          transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1)
        .btn-subtitle
          transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0.1s
        .btn-sound
          transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s
        .btn-question
          transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s
        .btn-gallery
          transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0.4s
        &.hide
          .btn
            transform: translateX(-40%)
            opacity: 0


        .btn
          //pointer-events: all
          cursor: pointer
          //transform: translateX(-40%)
          //opacity: 0
          transform: translateX(0)
          opacity: 1
          width: 100%
          //background: red
          margin: 0.2rem 0
          display: flex
          justify-content: flex-start
          align-items: center
          font-size: $fs-m
          color: white
          svg
            height: 0.4rem
            width: 0.4rem
            //background: #3a602e
            margin-right: 0.3rem

          //img
            height: 0.4rem
            display: block
            object-fit: cover
            //background: #2cff8c
          .switch
            line-height: 0
            margin-left: 0.3rem
            //margin-top: 0.08rem
            //background: #0030ff
            width: 0.8rem

      .questions
        margin-top: 1.1rem
        top: 0
        left: 0
        transform: translateX(100%)
        opacity: 0
        position: absolute
        width: 100%
        //background: #ffd81b
        //padding-left: 0.4rem
        transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1)
        &.active
          transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1) 0.7s
          transform: translateX(0)
          opacity: 1
      //.qr-menu
        transition: all 0.5s ease-out
        &.active
          transform: translateX(0)
          opacity: 1
      .menu-gallery
        transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1)
        &.active
          transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1) 1s
          transform: translateX(0)
          //opacity: 1




</style>